// Adds the admin JWT to backend calls that don't carry a valid Authorization header.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const EMPTY_BEARER = /^Bearer\s*(null|undefined)?\s*$/i;

const isBackendCall = (url) => typeof url === 'string' && (url.startsWith(`${BACKEND_URL}/api`) || url.startsWith('/api'));

const clearAdminSession = () => {
  try { ['admin_token', 'admin_authenticated', 'admin_email', 'is_super_admin'].forEach((k) => localStorage.removeItem(k)); } catch (e) { /* ignoré */ }
  if (window.location.search.includes('page=admin')) window.location.reload();
};

export const installAdminAuthFetch = () => {
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : input?.url;
    let adminToken = null;
    try { adminToken = localStorage.getItem('admin_token'); } catch (e) { /* stockage bloqué (navigateur intégré) */ }
    if (!adminToken || !isBackendCall(url) || url.includes('/api/admin/users/login')) {
      const res = await originalFetch(input, init);
      let wasAdmin = false;
      try { wasAdmin = localStorage.getItem('admin_authenticated') === 'true'; } catch (e) { /* ignoré */ }
      if (res.status === 401 && wasAdmin && !adminToken && isBackendCall(url)) clearAdminSession();
      return res;
    }

    const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined));
    const current = headers.get('Authorization');
    let injected = false;
    if (!current || EMPTY_BEARER.test(current)) {
      headers.set('Authorization', `Bearer ${adminToken}`);
      injected = true;
    }
    const response = await originalFetch(input, { ...init, headers });
    if (response.status === 401 && (injected || current === `Bearer ${adminToken}`)) clearAdminSession();
    return response;
  };
};
